import React from 'react';
import { Modal, Table, Tag } from 'antd';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

const CompanyDetailModal = ({ visible, onClose, companyData, loading }) => {
  const { t } = useTranslation();

  const jobColumns = [
    {
      title: t('recruitments.title'),
      dataIndex: 'title',
      key: 'title',
    },
    {
      title: t('recruitments.isActive'),
      dataIndex: 'isActive',
      key: 'isActive',
      render: (isActive) => (
        <Tag color={isActive ? 'green' : 'red'}>
          {isActive ? t('common.active') : t('common.inactive')}
        </Tag>
      ),
    },
    {
      title: t('dashboard.companyDetail.applicationsCount'),
      dataIndex: 'applicationsCount',
      key: 'applicationsCount',
      align: 'center',
    },
  ];

  return (
    <Modal
      title={companyData?.name || t('dashboard.companyDetail.title')}
      open={visible}
      onCancel={onClose}
      footer={null}
      width={800}
    >
      <div style={{ marginBottom: 16 }}>
        <p>
          <strong>{t('dashboard.companyDetail.totalJobs')}:</strong>{' '}
          {companyData?.jobsCount || 0}
        </p>
        <p>
          <strong>{t('dashboard.companyDetail.totalApplications')}:</strong>{' '}
          {companyData?.totalApplications || 0}
        </p>
      </div>
      <Table
        columns={jobColumns}
        dataSource={companyData?.jobs || []}
        loading={loading}
        rowKey="id"
        pagination={false}
      />
    </Modal>
  );
};

CompanyDetailModal.propTypes = {
  visible: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  companyData: PropTypes.object,
  loading: PropTypes.bool,
};

CompanyDetailModal.defaultProps = {
  companyData: null,
  loading: false,
};

export default CompanyDetailModal;
